import MainCard from './MainCard'
import StatsCard from './StatsCard'
import SecondaryCard from './ SecondaryCard'
import TeamPerformanceCard from './TeamPerformanceCard'
import { PerformanceAnalyticsCard } from './PerformanceAnalyticsCard'

export const OverviewContent = () => {
   return (
      <div className="mt-4">
         <div className="flex flex-col gap-4 mb-4 xl:flex-row">
            <div className="xl:w-3/5">
               <MainCard />
            </div>
            <div className="xl:w-2/5">
               <SecondaryCard />
            </div>
         </div>
         <div className="flex flex-col gap-4 mb-4 xl:flex-row">
            <div className="xl:w-3/5">
               <StatsCard />
            </div>
            <div className="xl:w-2/5">
               <TeamPerformanceCard />
            </div>
         </div>

         <PerformanceAnalyticsCard />
      </div>
   )
}
